import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bikrbjnoof: FaireBrandEntity = {
  token: "b_bikrbjnoof",
  type: "brand",
  name: "Listicle",
  avatarUrl:
    "https://cdn.faire.com/fastly/49eefe0015bbd10508214f7d36b2e9ac9c286b554de90c0fcb78482582452f06.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/05cc5bb1e330bd68237402868989a8e01b6b5f16d07603726ddb6e8824670fe3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/49eefe0015bbd10508214f7d36b2e9ac9c286b554de90c0fcb78482582452f06.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/05cc5bb1e330bd68237402868989a8e01b6b5f16d07603726ddb6e8824670fe3.jpeg",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 134,
  isTopShop: true,
  isInsider: true,
  description:
    "Listicle, a Women's comtemporary clothing wholesaler for our women to feel confident and sophisticated  yet feel free, and relaxed with its own style. A brand that can bring feminine to aventurous and can mix & match easily within just our brand. We'll always bring new styles while following the trend for our LISTICLE ladies.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:26.945Z",
    importedBy: "entity-db-cli",
  },
};
